"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnswerFailIcon = void 0;
const FormQuestionType_1 = __importDefault(require("@opsbase/lib-form/FormQuestionType"));
const isFailed_1 = __importDefault(require("@opsbase/lib-form/helpers/isFailed"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const usePerform_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformController/usePerform"));
const usePerformQuestion_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestion"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const FailIcon_1 = __importDefault(require("@opsbase/web-icons/icons/FailIcon"));
const react_1 = __importStar(require("react"));
const makeMyClasses = size => ({
    root: {
        borderRadius: '50%',
        width: size,
        height: size,
    },
});
function AnswerFailIcon(props) {
    const { size = 24 } = props;
    const { form } = (0, usePerform_1.default)();
    const { answer, question } = (0, usePerformQuestion_1.default)();
    const failed = !question || question.type === FormQuestionType_1.default.REPETITION
        ? (0, isFailed_1.default)(form, question)
        : answer.fail;
    const myCss = (0, web_css_1.default)(makeMyClasses, [size]);
    return (0, react_1.useMemo)(() => {
        if (!failed)
            return null;
        return (react_1.default.createElement("div", { className: myCss.root }, failed && react_1.default.createElement(FailIcon_1.default, { size: size, color: lib_palette_1.default.error })));
    }, [failed, myCss, size]);
}
exports.AnswerFailIcon = AnswerFailIcon;
exports.default = AnswerFailIcon;
